import { Box, Typography } from "@mui/material";
import { QUIZ } from "@/theme/quizTokens";

type ControlItem = {
    lead: string;
    body: string;
};

type Props = {
    dogName?: string;
};

export default function PlanControlBlock({ dogName }: Props) {
    const name = dogName?.trim() || "your dog";

    const items: ControlItem[] = [
        {
            lead: "Cancel whenever you like, no questions asked.",
            body: "A few clicks in your account, an email, or a phone call if you'd rather speak to someone. There's no notice period and no fee.",
        },
        {
            lead: "Skip or delay any box.",
            body: "Going away, or still working through the last one? Push it back and we'll pick up where you left off.",
        },
        {
            lead: `Swap recipes whenever ${name} fancies a change.`,
            body: "Nothing is locked in after the first box.",
        },
        {
            lead: "Change how often it arrives.",
            body: "If a 14-day box turns out to be too much or too little, move to a different plan in seconds.",
        },
        {
            lead: "We'll email you 2 days before every box.",
            body: "Nothing ever arrives as a surprise, and you've always got time to change it.",
        },
    ];

   return (
     <Box
         sx={{
            width: "100vw",
            position: "relative",
            left: "50%",
            transform: "translateX(-50%)",
            bgcolor: QUIZ.color.cream2,
            py: { xs: "32px", md: "36px" },
        }}
     >          <Box sx={{ width: "100%", maxWidth: { xs: "100%", sm: 520, md: 760 }, mx: "auto", px: { xs: "32px", md: 0 } }}>
                {/* "NO LOCK-IN" label */}
                <Typography
                    sx={{
                        fontFamily: QUIZ.font.button,
                        fontWeight: 700,
                        fontSize: { xs: 13, md: 18 },
                        letterSpacing: "1px",
                        textAlign: "center",
                        color: QUIZ.color.brown,
                        mb: 1,
                    }}
                >
                    NO LOCK-IN
                </Typography>

                {/* Heading */}
                <Typography
                    component="h2"
                    sx={{
                        fontFamily: QUIZ.font.display,
                        fontWeight: 900,
                        textTransform: "uppercase",
                        textAlign: "center",
                        color: QUIZ.color.brown,
                        fontSize: { xs: 30, md: 38 },
                        lineHeight: 1.15,
                        mb: { xs: 2, md: 3 },
                    }}
                >
                    You're in control, from box one
                </Typography>

                {/* Card */}
                <Box
                    sx={{
                        bgcolor: QUIZ.color.white,
                        borderRadius: "20px",
                        p: { xs: "20px", md: "24px 30px" },
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {items.map((item, i) => (
                        <Box
                            key={item.lead}
                            sx={{
                                py: { xs: "13px", md: "14px" },
                                borderTop: i === 0 ? "none" : `1px solid ${QUIZ.color.cream2}`,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: QUIZ.font.body,
                                    fontSize: { xs: 13, md: 16 },
                                    lineHeight: 1.5,
                                    color: QUIZ.color.brown,
                                }}
                            >
                                <Box component="span" sx={{ fontWeight: 700 }}>
                                    {item.lead}
                                </Box>{" "}
                                {item.body}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}
